import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "m-auto w-4/5 md:w-2/5" }
const _hoisted_3 = {
  key: 0,
  class: "mt-35 text-white"
}

import { HeroBannerImageContainingTextTileModel } from '@/types/B2CcontentServerContract';
import { computed, Ref } from 'vue';
import { ImageFileModel } from '@/types/B2BcontentServerContract';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroBannerImageContainingTextTileContent',
  props: {
    content: null,
    imageAspectRatio: null
  },
  setup(__props: any) {

const props = __props as {
    content: HeroBannerImageContainingTextTileModel,
    imageAspectRatio: number | object,
}



const image: Ref<ImageFileModel | undefined> = computed(() => {
    return props.content.imageWithCustomText.image?.model;
});

return (_ctx: any,_cache: any) => {
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(image))
        ? (_openBlock(), _createBlock(_component_ResponsiveImage, {
            key: 0,
            "image-url": _unref(image).url,
            "cache-bust": _unref(image).cachebust,
            "focus-points": _unref(image).focusPoints,
            focus: _unref(image).focus,
            zoom: _unref(image).zoom,
            alt: __props.content.imageWithCustomText.altText,
            flip: _unref(image).flip,
            "aspect-ratio": __props.imageAspectRatio,
            "original-width": _unref(image).width,
            "original-height": _unref(image).height,
            "width-on-screen": { md: 50 },
            mode: "contain"
          }, null, 8, ["image-url", "cache-bust", "focus-points", "focus", "zoom", "alt", "flip", "aspect-ratio", "original-width", "original-height"]))
        : _createCommentVNode("", true)
    ]),
    (__props.content.link)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(RouterLinkConditional, {
            class: "c-button c-button--outline c-button--current-color",
            to: __props.content.link.url,
            "spa-enabled": __props.content.link.spaLink,
            title: __props.content.link.text || __props.content.link.title,
            target: __props.content.link.target
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.content.link.text || __props.content.link.title), 1)
            ]),
            _: 1
          }, 8, ["to", "spa-enabled", "title", "target"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})